/**
 * The terminal decline as it shows on the SURVEY row: the materialized
 * consequence of a `not_performed` Variant Check answer (D10), not its storage.
 * The answer itself is a `StepVariantResponse` document (plan 029).
 *
 * Read by the classic-survey readers only, to keep a decliner out of the
 * response averages — a dismissed row carries no rating, frequency or duration.
 */ export function isDismissedSurvey(survey) {
    return survey.status === 'dismissed';
}
/**
 * One pass over a step's Variant Check answers. Anchored on the ENTITY: a
 * verdict is a document of its own, so it counts the moment it is given —
 * whether or not the classic survey around it was ever finished.
 */ export function summarizeVariantCheck(responses) {
    const summary = {
        same: 0,
        different: 0,
        notPerformed: 0
    };
    for (const { verdict } of responses ?? []){
        if (verdict === 'same') summary.same++;
        else if (verdict === 'different') summary.different++;
        else if (verdict === 'not_performed') summary.notPerformed++;
    }
    return summary;
}
/**
 * Everyone who answered the Variant Check — the ONE denominator of every
 * "X von Y" line over it (D12), decliners included. They answered the question
 * that was asked ("do you do it like this?") with "I don't do it at all", which
 * is a statement about this step, not an absence of one.
 */ export function variantRespondentCount(summary) {
    return summary.same + summary.different + summary.notPerformed;
}

//# sourceMappingURL=variant-check.js.map